<template>
  <div>
    <div class="py-3"></div>

    <!-- 상단: 하우스애드 통합 탭 -->
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar color="light-blue darken-3" dark flat>
        <v-toolbar-title>
          <v-icon left>mdi-advertisements</v-icon>
          하우스애드
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab" background-color="grey lighten-4" show-arrows>
        <v-tab>
          <v-icon left small>mdi-advertisements</v-icon>광고 관리
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-gift-outline</v-icon>보상 관리
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-account-check</v-icon>참여 정보
        </v-tab>
      </v-tabs>
    </v-card>

    <!--
      각 탭은 기존 화면 컴포넌트를 그대로 재사용한다.
      v-tab-item 은 지연 렌더(lazy)라 처음 선택한 탭만 mounted → 불필요한 조회가 안 나간다.
    -->
    <v-tabs-items v-model="tab" class="housead-tabs-items">
      <v-tab-item>
        <HouseAd_AdManage />
      </v-tab-item>
      <v-tab-item>
        <HouseAd_RewardType />
      </v-tab-item>
      <v-tab-item>
        <HouseAd_Participation />
      </v-tab-item>
    </v-tabs-items>

    <div class="py-6"></div>
  </div>
</template>

<script>
import HouseAd_AdManage from './HouseAd_AdManage.vue';
import HouseAd_RewardType from './HouseAd_RewardType.vue';
import HouseAd_Participation from './HouseAd_Participation.vue';

// 탭 인덱스 ↔ 쿼리스트링 키 (새로고침/북마크 시 탭 유지)
const TAB_KEYS = ['ad', 'reward', 'participation'];

export default {
  name: 'HouseAd_Manage',
  components: {
    HouseAd_AdManage,
    HouseAd_RewardType,
    HouseAd_Participation,
  },
  data: () => ({
    tab: 0,
  }),
  created() {
    const key = this.$route.query.tab;
    const idx = TAB_KEYS.indexOf(key);
    if (idx >= 0) this.tab = idx;
  },
  watch: {
    tab(v) {
      const key = TAB_KEYS[v] || TAB_KEYS[0];
      if (this.$route.query.tab === key) return;
      // 같은 경로에서 쿼리만 교체 (중복 내비게이션 오류는 무시)
      this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
    },
  },
};
</script>

<style scoped>
/*
  v-tabs-items(VWindow)는 기본 배경이 흰색이라, 자식 화면 카드(max-width:95%)와
  페이지 배경(#F5F5F5) 사이에 전체폭 흰 띠가 생겨 이질감이 있었다.
  투명 처리해서 다른 화면들과 동일한 회색 배경이 비치게 한다.
*/
.housead-tabs-items,
.housead-tabs-items >>> .v-window__container,
.housead-tabs-items >>> .v-window-item {
  background-color: transparent !important;
}
</style>
